//#region Imports

import { Component } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { IconComponent } from '../icon/icon.component';

//#endregion

@Component({
    selector: 'l-toast',
    standalone: true,
    templateUrl: './toast.component.html',
    imports: [
        ToastModule,
        IconComponent
    ]
})
export class ToastComponent {}
